import styled from '@emotion/styled'

export const SummaryContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  align-items: stretch;
  padding: 18px 20px;
  color: white;
  background: #353c4b;

  strong,
  span {
    display: block;
  }

  span {
    color: #b7c1d3;
    font-size: 12px;
  }

  > div:nth-of-type(n + 2):nth-of-type(-n + 4) {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
  }

  > div:nth-of-type(4) strong {
    color: #ffb24d;
    font-size: 21px;
  }

  @media screen and (max-width: 1220px) {
    display: none;
  }
`

export const SummaryActions = styled.div`
  display: flex;
  min-width: 145px;
  flex-direction: column;
  gap: 7px;
`

export const ShareAction = styled.div`
  min-width: 145px;
`

export const ShareButton = styled.button`
  width: 100%;
  min-height: 42px;
  padding: 8px 13px;
  border: 2px solid #7b67ff;
  border-radius: 7px;
  color: #fff;
  background: #533bff;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;

  &:hover:not(:disabled),
  &:focus-visible {
    border-color: #ff8e00;
    outline: none;
    background: #654fff;
  }

  &:disabled {
    border-color: #596170;
    color: #8f9aab;
    background: #2a2f38;
    cursor: not-allowed;
  }
`

export const ShareMessage = styled.small<{ $error?: boolean }>`
  display: block;
  margin-top: 4px;
  color: ${({ $error }) => ($error ? '#ff9b99' : '#b7c1d3')};
  font-size: 10px;
  line-height: 1.3;
  text-align: center;
`

export const OrderAction = styled.div`
  min-width: 145px;
`

export const OrderButton = styled(ShareButton)`
  border-color: #ff9b1a;
  color: #202327;
  background: #ff9b1a;

  &:hover:not(:disabled),
  &:focus-visible {
    border-color: #ffc36f;
    color: #202327;
    background: #ffad42;
  }
`

export const StickySummaryContainer = styled(SummaryContainer)`
  display: none;
  position: fixed;
  z-index: 100;
  right: 0;
  bottom: 0;
  left: 0;
  width: min(calc(100vw - 64px), 1136px);
  border-top: 3px solid #533bff;
  margin: 0 auto;
  box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.42);

  @media screen and (max-width: 1220px) {
    display: grid;
    grid-template-columns: repeat(3, 1fr) minmax(92px, 1.2fr);
    gap: 8px;
    padding: 11px 12px;

    > div:first-of-type {
      display: none;
    }

    > div {
      text-align: center;
    }

    span {
      font-size: 10px;
    }

    strong {
      font-size: 13px;
    }

    > div:nth-of-type(4) strong {
      font-size: 15px;
    }

    [data-share-action] {
      min-width: 0;
    }

    [data-summary-actions],
    [data-order-action] {
      min-width: 0;
    }

    [data-share-button],
    [data-order-button] {
      min-height: 38px;
      padding: 5px 7px;
      font-size: 10px;
    }

    [data-share-message] {
      display: none;
    }
  }

  @media screen and (max-width: 420px) {
    width: calc(100vw - 24px);
  }
`
